import { create } from 'zustand';

interface PendingNotificationsStore {
  pendingNotifications: string[];
  addPendingNotification: (id: string) => void;
  removePendingNotification: (id: string) => void;
}

export const usePendingNotificationsStore = create<PendingNotificationsStore>((set) => ({
  pendingNotifications: [],
  addPendingNotification: (id) =>
    set((state) => ({
      pendingNotifications: [...state.pendingNotifications, id],
    })),
  removePendingNotification: (id) =>
    set((state) => ({
      pendingNotifications: state.pendingNotifications.filter((notificationId) => notificationId !== id),
    })),
}));
